import { Loader2 } from 'lucide-react';
import { type ReactElement, type SVGAttributes } from 'react';

import { cn } from '@shared/utils';

export interface SpinnerProps extends Omit<SVGAttributes<SVGSVGElement>, 'children'> {
  readonly size?: 'sm' | 'md' | 'lg';
  readonly label?: string;
}

const sizeMap = {
  sm: 'size-4',
  md: 'size-5',
  lg: 'size-7',
} as const;

export function Spinner({
  size = 'md',
  label,
  className,
  ...rest
}: Readonly<SpinnerProps>): ReactElement {
  if (label !== undefined) {
    return (
      <output className="inline-flex items-center gap-2">
        <Loader2
          aria-hidden="true"
          className={cn(sizeMap[size], 'animate-spin text-brand', className)}
          {...rest}
        />
        <span className="sr-only">{label}</span>
      </output>
    );
  }

  return (
    <Loader2
      aria-hidden="true"
      className={cn(sizeMap[size], 'animate-spin text-brand', className)}
      {...rest}
    />
  );
}
